<div class="overlay-inner-wrapper">
  <header class="header-2 scroll-x">
    <div class="branding">
      <span class="title">{{ 'Mangelbaum verwalten' | mrTranslate }}</span>
    </div>
    <div class="header-actions">
      <div class="clr-form-horizontal d-f clr-align-items-center">
        @if (objekte(); as objekte) {
          <clr-select-container class="nym margin-12-r">
            <label style="width: auto; padding: 0 2px">
              @if (selectedObjektTyp()?.symbol; as symbol) {
                <cds-icon size="24" class="fill-black" [shape]="'objekttyp' + symbol" />
              }
            </label>
            <select
              clrSelect
              name="objekt"
              class="cur-color"
              [(ngModel)]="otypid"
              [ngModelOptions]="{ standalone: true }">
              @for (typ of objekte | keyvalue; track typ.key) {
                <option [ngValue]="+typ.key">{{ typ.value.bezeichnung }}</option>
              }
            </select>
          </clr-select-container>
        } @else {
          <clr-spinner class="margin-12-r" [clrSmall]="true" />
        }
        <clr-checkbox-container class="nym">
          <clr-checkbox-wrapper>
            <label>{{ 'Liste' | mrTranslate }}</label>
            <input type="checkbox" clrToggle [(ngModel)]="isListeMode" />
          </clr-checkbox-wrapper>
        </clr-checkbox-container>
      </div>
      <div class="header-nav">
        <a class="nav-link nav-icon" (click)="historieId.set(null); isHistorieModalOpen.set(true)">
          <cds-icon shape="history" size="22" [title]="'Historie' | mrTranslate" />
        </a>
        <a class="nav-link nav-icon close" (click)="close()">
          <cds-icon shape="times" size="22" [title]="'Schliessen' | mrTranslate" />
        </a>
      </div>
    </div>
  </header>
  @if (isListeMode()) {
    <div class="width100 h-60 d-f col padding-12">
      @if (liste.isLoading()) {
        <clr-spinner class="centred" />
      } @else if (liste.value()?.columns?.length) {
        @let table = liste.value();
        <clr-datagrid class="datagrid-compact fill-space">
          @for (column of table.columns; track column.id) {
            <clr-dg-column [clrDgField]="column.id" [style.min-width.px]="CELL_CONTROLS[column.id] ? 130 : null">
              <ng-container *clrDgHideableColumn="{ hidden: column.id | get: hideZFelds | hideIDColumns: ['stammid'] }">
                {{ zFelds()[column.id] ?? column.id | mrTranslate }}
              </ng-container>
            </clr-dg-column>
          }
          <ng-template
            clrVirtualScroll
            let-row
            [clrVirtualRowsOf]="table.rows"
            [clrVirtualRowsTrackBy]="(_, row) => row?.ID">
            <clr-dg-row [clrDgItem]="row">
              @for (cell of table.columns; track cell.id) {
                @if (CELL_CONTROLS[cell.id]; as field) {
                  @switch (cell.id) {
                    @case ('Preis')
                    @case ('Abnutzungsäquivalent')
                    @case ('Anteilige Wichtung') {
                      <clr-dg-cell>
                        <clr-number-input-container>
                          <input
                            type="number"
                            clrNumberInput
                            [name]="cell.id"
                            [readOnly]="!allowMBCreate"
                            #m="ngModel"
                            [ngModel]="row[cell.id]"
                            (ngModelChange)="updateField(m, row, field)"
                            min="0"
                            [ngModelOptions]="{ standalone: true, updateOn: 'blur' }" />
                          <clr-control-error *clrIfError="'min'">{{ 'Min' | mrTranslate }} 0</clr-control-error>
                          @if (m.dirty) {
                            <clr-control-success>{{ 'Erfolgreich gespeichert' | mrTranslate }}</clr-control-success>
                          }
                          <clr-control-error *clrIfError="'server'; error as err">{{ err }}</clr-control-error>
                        </clr-number-input-container>
                      </clr-dg-cell>
                    }
                    @case ('Fehlerklasse') {
                      <clr-dg-cell>
                        <clr-select-container clrInline>
                          <select
                            clrSelect
                            [name]="cell.id"
                            #m="ngModel"
                            [ngModel]="row[cell.id]"
                            (ngModelChange)="updateField(m, row, field)"
                            [ngModelOptions]="{ standalone: true }">
                            @for (fk of rangeFK(); track $index) {
                              <option [value]="fk">{{ fk }}</option>
                            }
                          </select>
                          @if (m.dirty) {
                            <clr-control-success>{{ 'Erfolgreich gespeichert' | mrTranslate }}</clr-control-success>
                          }
                          <clr-control-error *clrIfError="'server'; error as err">{{ err }}</clr-control-error>
                        </clr-select-container>
                      </clr-dg-cell>
                    }
                    @case ('Gattung Weiche') {
                      <clr-dg-cell>
                        <clr-control-container>
                          <app-datalist-input
                            [name]="cell.id"
                            #m="ngModel"
                            [ngModel]="row[cell.id]"
                            (ngModelChange)="updateField(m, row, field)"
                            [ngModelOptions]="{ standalone: true }"
                            [insert]="false"
                            [datalist]="gattungen()"
                            [labelPath]="'Bezeichnung'"
                            [valuePath]="'ID'" />
                          @if (m.dirty) {
                            <clr-control-success>{{ 'Erfolgreich gespeichert' | mrTranslate }}</clr-control-success>
                          }
                          <clr-control-error *clrIfError="'server'; error as err">{{ err }}</clr-control-error>
                        </clr-control-container>
                      </clr-dg-cell>
                    }
                    @case ('Abteilung') {
                      <clr-dg-cell>
                        <clr-control-container>
                          <app-datalist-input
                            [name]="cell.id"
                            #m="ngModel"
                            [ngModel]="row[cell.id]"
                            (ngModelChange)="updateField(m, row, field)"
                            [ngModelOptions]="{ standalone: true }"
                            [datalist]="used().zuAbt" />
                          @if (m.dirty) {
                            <clr-control-success>{{ 'Erfolgreich gespeichert' | mrTranslate }}</clr-control-success>
                          }
                          <clr-control-error *clrIfError="'server'; error as err">{{ err }}</clr-control-error>
                        </clr-control-container>
                      </clr-dg-cell>
                    }
                    @case ('LV') {
                      <clr-dg-cell>
                        <clr-control-container>
                          <app-datalist-input
                            [name]="cell.id"
                            #m="ngModel"
                            [ngModel]="row[cell.id]"
                            (ngModelChange)="updateField(m, row, field)"
                            [ngModelOptions]="{ standalone: true }" />
                          @if (m.dirty) {
                            <clr-control-success>{{ 'Erfolgreich gespeichert' | mrTranslate }}</clr-control-success>
                          }
                          <clr-control-error *clrIfError="'server'; error as err">{{ err }}</clr-control-error>
                        </clr-control-container>
                      </clr-dg-cell>
                    }
                    @case ('Kav® Einheit') {
                      <clr-dg-cell>
                        <clr-control-container>
                          <app-datalist-input
                            [name]="cell.id"
                            #m="ngModel"
                            [ngModel]="row[cell.id]"
                            (ngModelChange)="updateField(m, row, field)"
                            [ngModelOptions]="{ standalone: true }" />
                          @if (m.dirty) {
                            <clr-control-success>{{ 'Erfolgreich gespeichert' | mrTranslate }}</clr-control-success>
                          }
                          <clr-control-error *clrIfError="'server'; error as err">{{ err }}</clr-control-error>
                        </clr-control-container>
                      </clr-dg-cell>
                    }
                    @case ('Equipment') {
                      <clr-dg-cell>
                        @if (useEquipment()) {
                          <clr-control-container>
                            <app-datalist-input
                              [name]="cell.id"
                              #m="ngModel"
                              [ngModel]="row[cell.id]"
                              (ngModelChange)="updateField(m, row, field)"
                              required
                              [ngModelOptions]="{ standalone: true }"
                              [datalist]="equipments()"
                              [labelPath]="'Bezeichnung'"
                              [valuePath]="'Bezeichnung'"
                              [insert]="insertIn('Equipment')" />
                            <clr-control-error *clrIfError="'required'">
                              {{ 'Erforderlich' | mrTranslate }}
                            </clr-control-error>
                            @if (m.dirty) {
                              <clr-control-success>{{ 'Erfolgreich gespeichert' | mrTranslate }}</clr-control-success>
                            }
                            <clr-control-error *clrIfError="'server'; error as err">{{ err }}</clr-control-error>
                          </clr-control-container>
                        } @else {
                          <clr-control-container>
                            <app-datalist-input
                              [name]="cell.id"
                              #m="ngModel"
                              [ngModel]="row[cell.id]"
                              (ngModelChange)="updateField(m, row, 'Equipment')"
                              [ngModelOptions]="{ standalone: true }"
                              [datalist]="used().Equipment" />
                            @if (m.dirty) {
                              <clr-control-success>{{ 'Erfolgreich gespeichert' | mrTranslate }}</clr-control-success>
                            }
                            <clr-control-error *clrIfError="'server'; error as err">{{ err }}</clr-control-error>
                          </clr-control-container>
                        }
                      </clr-dg-cell>
                    }
                    @case ('ZFeld1')
                    @case ('ZFeld2')
                    @case ('ZFeld3')
                    @case ('ZFeld4')
                    @case ('ZFeld5') {
                      <clr-dg-cell>
                        <clr-control-container>
                          <app-datalist-input
                            [name]="cell.id"
                            #m="ngModel"
                            [datalist]="used()[cell.id]"
                            [ngModel]="row[cell.id]"
                            (ngModelChange)="updateField(m, row, field)"
                            [ngModelOptions]="{ standalone: true }" />
                          @if (m.dirty) {
                            <clr-control-success>{{ 'Erfolgreich gespeichert' | mrTranslate }}</clr-control-success>
                          }
                          <clr-control-error *clrIfError="'server'; error as err">{{ err }}</clr-control-error>
                        </clr-control-container>
                      </clr-dg-cell>
                    }
                  }
                } @else {
                  <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                }
              }
            </clr-dg-row>
          </ng-template>
          <clr-dg-footer>{{ table.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
        </clr-datagrid>
      }
    </div>
  } @else {
    <div clrModalHost class="h-60">
      <clr-side-panel
        #navPanel
        class="left-side-panel h-100-stop"
        [clrSidePanelPosition]="'left'"
        [clrSidePanelBackdrop]="false"
        [clrSidePanelPinned]="true"
        [clrSidePanelPinnable]="true"
        [clrSidePanelOpen]="isBaumPanelOpen()"
        (clrSidePanelOpenChange)="isBaumPanelOpen.set($event)">
        <h3 class="side-panel-title">{{ selectedObjektTyp()?.bezeichnung }} {{ 'Baum' | mrTranslate }}</h3>
        <div class="side-panel-body h-100 h-100-parent scroll-y">
          @if (treeLevel0.isLoading()) {
            <clr-spinner class="centred" />
          } @else {
            <clr-tree [clrLazy]="true">
              <clr-tree-node
                *clrRecursiveFor="let node of treeLevel0.value(); getChildren: getChildren"
                [clrExpandable]="node.Route.level != BAUM_LEVEL.FK"
                [clrDisabled]="node.deleted">
                <a
                  class="clr-treenode-link"
                  [class.active]="selected() == node"
                  (click)="selected.set(node)"
                  [title]="node.ID">
                  <cds-icon [shape]="BAUM_ICON[node.Route.level]" />
                  {{ node.Bezeichnung }}
                </a>
                @if (selected() == node) {
                  <div class="btn-group btn-icon btn-primary btn-sm">
                    @if (node.Route.level == BAUM_LEVEL.FK) {
                      <button class="btn" [disabled]="!allowMBCreate()" (click)="editingId = selected().ID; editNode()">
                        <clr-tooltip>
                          <cds-icon clrTooltipTrigger shape="pencil" />
                          <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'md'">
                            {{ 'Eintrag bearbeiten' | mrTranslate }}
                          </clr-tooltip-content>
                        </clr-tooltip>
                      </button>
                      <button
                        class="btn btn-outline"
                        (click)="historieId.set(selected().ID); isHistorieModalOpen.set(true)">
                        <clr-tooltip>
                          <cds-icon clrTooltipTrigger shape="history" />
                          <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'md'">
                            {{ 'Historie anzeigen' | mrTranslate }}
                          </clr-tooltip-content>
                        </clr-tooltip>
                      </button>
                    } @else {
                      <button class="btn" (click)="copyNode()">
                        <clr-tooltip>
                          <cds-icon clrTooltipTrigger shape="copy" />
                          <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'md'">
                            {{ 'Eintrag kopieren' | mrTranslate }}
                          </clr-tooltip-content>
                        </clr-tooltip>
                      </button>
                    }
                    @if (node.Route.level >= BAUM_LEVEL.Mangel) {
                      <button class="btn btn-danger" [disabled]="!allowMBCreate()" (click)="deleteNode()">
                        <clr-tooltip>
                          <cds-icon clrTooltipTrigger shape="times" />
                          <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'md'">
                            {{ 'Eintrag löschen' | mrTranslate }}
                          </clr-tooltip-content>
                        </clr-tooltip>
                      </button>
                    }
                  </div>
                }
              </clr-tree-node>
            </clr-tree>
          }
        </div>
        <div class="side-panel-footer w-100-p clr-justify-content-between">
          <button class="btn btn-icon btn-primary" [disabled]="!allowMBCreate()" (click)="form.reset(); selected.set(undefined)">
            <clr-tooltip>
              <cds-icon clrTooltipTrigger shape="file" />
              <clr-tooltip-content [clrPosition]="'top-right'" [clrSize]="'md'">
                {{ 'Neuen Eintrag hinzufügen' | mrTranslate }}
              </clr-tooltip-content>
            </clr-tooltip>
          </button>
          <button class="btn btn-icon" (click)="treeLevel0.reload()">
            <clr-tooltip>
              <cds-icon clrTooltipTrigger shape="refresh" />
              <clr-tooltip-content [clrPosition]="'top-left'" [clrSize]="'md'">
                {{ 'Aktualisieren' | mrTranslate }}
              </clr-tooltip-content>
            </clr-tooltip>
          </button>
        </div>
      </clr-side-panel>
      <div class="side-panel-toggle left">
        @if (isBaumPanelOpen()) {
          <button type="button" class="btn btn-icon btn-info" (click)="isBaumPanelOpen.set(false)">
            <cds-icon shape="angle-double" direction="left" size="32" />
          </button>
        } @else {
          <button type="button" class="btn btn-icon btn-info" (click)="isBaumPanelOpen.set(true)">
            <cds-icon shape="angle-double" direction="right" size="32" />
          </button>
        }
      </div>
      <div class="padding-48-l padding-6-r padding-12-tb h-100 w-100-p">
        <h3>{{ 'Zuordnung ' + (id() ? 'bearbeiten' : 'erstellen') | mrTranslate }}</h3>
        <form
          clrForm
          (ngSubmit)="saveIfValid()"
          [formGroup]="form"
          clrLayout="vertical"
          class="width100 clr-row nxm"
          style="max-width: 1200px">
          <div class="clr-col">
            @if (isWeiche() || isGleis()) {
              <clr-control-container>
                @let title = 'Gattung' | mrTranslate;
                <label [class.clr-required-mark]="isGleis()">{{ title }}</label>
                <app-datalist-input
                  formControlName="GattungID"
                  [datalist]="gattungen()"
                  [labelPath]="'Bezeichnung'"
                  [valuePath]="'ID'"
                  [insert]="isGleis() ? insertIn('Gattungen') : false" />
                <clr-control-error *clrIfError="'required'">{{ 'Erforderlich' | mrTranslate }}</clr-control-error>
                @if (isGleis()) {
                  <clr-control-helper>
                    <button type="button" class="btn btn-sm" (click)="editBaseItems('Gattungen')">
                      {{ 'Bearbeiten' | mrTranslate }}
                    </button>
                  </clr-control-helper>
                }
              </clr-control-container>
            }
            @if (isGleis()) {
              <clr-control-container>
                <label class="clr-required-mark">{{ 'StammItems' | mrTranslate }}</label>
                <app-datalist-input
                  formControlName="StammID"
                  [datalist]="stammItems()[gattungId()]"
                  [labelPath]="'Bezeichnung'"
                  [valuePath]="'ID'"
                  [insert]="insertIn('StammItems')" />
                <clr-control-error *clrIfError="'required'">{{ 'Erforderlich' | mrTranslate }}</clr-control-error>
                <clr-control-helper>
                  <button
                    type="button"
                    class="btn btn-sm"
                    (click)="editBaseItems('StammItems')"
                    [disabled]="!stammTable()">
                    {{ 'Bearbeiten' | mrTranslate }}
                  </button>
                </clr-control-helper>
              </clr-control-container>
            }
            <clr-control-container>
              <label class="clr-required-mark">{{ 'Prüfart' | mrTranslate }}</label>
              <app-datalist-input
                formControlName="PruefartID"
                [datalist]="pruefarten()"
                [labelPath]="'Bezeichnung'"
                [valuePath]="'ID'"
                [insert]="insertIn('Prüfarten')" />
              <clr-control-error *clrIfError="'required'">{{ 'Erforderlich' | mrTranslate }}</clr-control-error>
              <clr-control-helper>
                <button type="button" class="btn btn-sm" (click)="editBaseItems('Prüfarten')">
                  {{ 'Bearbeiten' | mrTranslate }}
                </button>
              </clr-control-helper>
            </clr-control-container>
            @if (!isGleis()) {
              <clr-control-container>
                <label class="clr-required-mark">{{ 'Lage' | mrTranslate }}</label>
                <app-datalist-input
                  formControlName="LageID"
                  [datalist]="lagen()"
                  [labelPath]="'Bezeichnung'"
                  [valuePath]="'ID'"
                  [insert]="insertIn('Lagen')" />
                <clr-control-error *clrIfError="'required'">{{ 'Erforderlich' | mrTranslate }}</clr-control-error>
                <clr-control-helper>
                  <button type="button" class="btn btn-sm" (click)="editBaseItems('Lagen')">
                    {{ 'Bearbeiten' | mrTranslate }}
                  </button>
                </clr-control-helper>
              </clr-control-container>
            }
            <clr-control-container>
              <label class="clr-required-mark">{{ 'Mangel' | mrTranslate }}</label>
              <app-datalist-input
                formControlName="MangelID"
                [datalist]="maengel()"
                [labelPath]="'Bezeichnung'"
                [valuePath]="'ID'"
                [insert]="insertIn('Mängel')" />
              <clr-control-error *clrIfError="'required'">{{ 'Erforderlich' | mrTranslate }}</clr-control-error>
              <clr-control-helper>
                <button type="button" class="btn btn-sm" (click)="editBaseItems('Mängel')">
                  {{ 'Bearbeiten' | mrTranslate }}
                </button>
              </clr-control-helper>
            </clr-control-container>
            <clr-control-container>
              <label class="clr-required-mark">{{ 'Instandsetzung' | mrTranslate }}</label>
              <app-datalist-input
                formControlName="InstandsetzungID"
                [datalist]="instandsetzungen()"
                [labelPath]="'Bezeichnung'"
                [valuePath]="'ID'"
                [insert]="insertIn('Instandsetzungen')" />
              <clr-control-error *clrIfError="'required'">{{ 'Erforderlich' | mrTranslate }}</clr-control-error>
              <clr-control-helper>
                <button type="button" class="btn btn-sm" (click)="editBaseItems('Instandsetzungen')">
                  {{ 'Bearbeiten' | mrTranslate }}
                </button>
              </clr-control-helper>
            </clr-control-container>
            <clr-radio-container clrInline>
              <label [class.clr-required-mark]="useFK()">
                {{ 'Fehlerklasse' | mrTranslate }}
              </label>
              @for (fk of rangeFK(); track $index) {
                <clr-radio-wrapper>
                  <input type="radio" clrRadio formControlName="FK" [value]="fk" />
                  <label>{{ fk }}</label>
                </clr-radio-wrapper>
              }
              <clr-control-error *clrIfError="'required'">{{ 'Erforderlich' | mrTranslate }}</clr-control-error>
            </clr-radio-container>
            <clr-control-container>
              <label>{{ 'Mengeneinheit' | mrTranslate }}</label>
              <app-datalist-input
                formControlName="MengeneinheitID"
                [datalist]="meh()"
                [labelPath]="'Bezeichnung'"
                [valuePath]="'ID'"
                [insert]="insertIn('Mengeneinheiten')" />
              <clr-control-helper>
                <button type="button" class="btn btn-sm" (click)="editBaseItems('Mengeneinheiten')">
                  {{ 'Bearbeiten' | mrTranslate }}
                </button>
              </clr-control-helper>
            </clr-control-container>
          </div>
          <div class="clr-col">
            <fieldset class="border padding-9 margin-24-t">
              <legend class="clr-control-label w-auto">{{ 'Bedingungen' | mrTranslate }}</legend>
              <clr-checkbox-container class="nm">
                <clr-checkbox-wrapper>
                  <label>{{ 'Bedingung' | mrTranslate }}</label>
                  <input type="checkbox" clrToggle formControlName="Bedingung" />
                </clr-checkbox-wrapper>
              </clr-checkbox-container>
              @if (form.value.Bedingung) {
                <div class="clr-row">
                  <clr-radio-container clrInline class="clr-col">
                    <label>{{ 'Auslöser' | mrTranslate }}</label>
                    @for (bed of BEDINGUNGEN; track $index) {
                      <clr-radio-wrapper>
                        <input type="radio" clrRadio formControlName="BedAusloeserMin" [value]="bed" />
                        <label>{{ bed }}</label>
                      </clr-radio-wrapper>
                    }
                  </clr-radio-container>
                  <clr-number-input-container class="clr-col">
                    <label>{{ 'Wert' | mrTranslate }}</label>
                    <input type="number" clrNumberInput formControlName="BedMin" />
                    <clr-control-error *clrIfError="'required'">{{ 'Erforderlich' | mrTranslate }}</clr-control-error>
                    <clr-control-error *clrIfError="'min'">{{ 'Min' | mrTranslate }} 0</clr-control-error>
                  </clr-number-input-container>
                </div>
                <clr-checkbox-container>
                  <clr-checkbox-wrapper>
                    <label>{{ 'und' | mrTranslate }}</label>
                    <input type="checkbox" clrToggle formControlName="AndBedingung" />
                  </clr-checkbox-wrapper>
                </clr-checkbox-container>
                @if (form.value.AndBedingung) {
                  <div class="clr-row">
                    <clr-radio-container clrInline class="clr-col">
                      <label>{{ 'Auslöser' | mrTranslate }}</label>
                      @for (bed of BEDINGUNGEN; track $index) {
                        <clr-radio-wrapper>
                          <input type="radio" clrRadio formControlName="BedAusloeserMax" [value]="bed" />
                          <label>{{ bed }}</label>
                        </clr-radio-wrapper>
                      }
                    </clr-radio-container>
                    <clr-number-input-container class="clr-col">
                      <label>{{ 'Wert' | mrTranslate }}</label>
                      <input type="number" clrNumberInput formControlName="BedMax" />
                      <clr-control-error *clrIfError="'required'">{{ 'Erforderlich' | mrTranslate }}</clr-control-error>
                      <clr-control-error *clrIfError="'min'">{{ 'Min' | mrTranslate }} 0</clr-control-error>
                    </clr-number-input-container>
                  </div>
                }
                <clr-radio-container clrInline>
                  <label>{{ 'Einheiten' | mrTranslate }}</label>
                  @for (beh of BED_EINHEITEN; track $index) {
                    <clr-radio-wrapper>
                      <input type="radio" clrRadio formControlName="BedEinheit" [value]="beh" />
                      <label>{{ beh }}</label>
                    </clr-radio-wrapper>
                  }
                </clr-radio-container>
              }
            </fieldset>

            <clr-number-input-container>
              <label>{{ 'Preis' | mrTranslate }}</label>
              <input type="number" clrNumberInput formControlName="Preis" />
              <clr-control-error *clrIfError="'min'">{{ 'Min' | mrTranslate }} 0</clr-control-error>
            </clr-number-input-container>
            <clr-control-container>
              <label [class.clr-required-mark]="useAbteilung()">{{ 'Abteilung' | mrTranslate }}</label>
              <app-datalist-input formControlName="Abteilung" [datalist]="used().zuAbt" />
              <clr-control-error *clrIfError="'required'">{{ 'Erforderlich' | mrTranslate }}</clr-control-error>
            </clr-control-container>
            @if (useEquipment()) {
              <clr-control-container>
                <label class="clr-required-mark">{{ 'Equipment' | mrTranslate }}</label>
                <app-datalist-input
                  formControlName="Equipment"
                  [datalist]="equipments()"
                  [labelPath]="'Bezeichnung'"
                  [valuePath]="'Bezeichnung'"
                  [insert]="insertIn('Equipment')" />
                <clr-control-error *clrIfError="'required'">{{ 'Erforderlich' | mrTranslate }}</clr-control-error>
                <clr-control-helper>
                  <button type="button" class="btn btn-sm" (click)="editBaseItems('Equipment')">
                    {{ 'Bearbeiten' | mrTranslate }}
                  </button>
                </clr-control-helper>
              </clr-control-container>
            } @else {
              <clr-control-container>
                <label>{{ 'Equipment' | mrTranslate }}</label>
                <app-datalist-input formControlName="Equipment" [datalist]="used().Equipment" />
              </clr-control-container>
            }
            <clr-control-container>
              <label>{{ 'LV' | mrTranslate }}</label>
              <app-datalist-input formControlName="LVPos" [datalist]="used().LVPos" />
            </clr-control-container>

            @for (zFeld of zFelds() | keyvalue; track $index) {
              <clr-control-container>
                <label class="clr-required-mark">{{ zFeld.value }}</label>
                <app-datalist-input [formControlName]="zFeld.key" [datalist]="used()[zFeld.key]" />
                <clr-control-error *clrIfError="'required'">{{ 'Erforderlich' | mrTranslate }}</clr-control-error>
              </clr-control-container>
            }
          </div>
          <div class="btn-group clr-col-12 margin-32-t">
            <button type="submit" class="btn btn-success margin-6-l" [clrLoading]="saveState()">
              {{ (id() ? 'Speichern' : 'Erstellen') | mrTranslate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  }
</div>

<app-baseitems-wrapper [(isModalOpen)]="isBaseModalOpen" [route]="editTabelle()" (refresh)="refreshTabelle($event)" />

<clr-modal
  [clrModalSize]="'lg'"
  [clrModalOpen]="isHistorieModalOpen()"
  (clrModalOpenChange)="isHistorieModalOpen.set($event)">
  <h3 class="modal-title">{{ 'Historie' | mrTranslate }}</h3>
  <div class="modal-body d-f col" style="height: 45vh">
    @if (historie.isLoading()) {
      <clr-spinner class="centred" />
    } @else if (historie.value().columns.length) {
      @let table = historie.value();
      <clr-datagrid class="datagrid-compact fill-space">
        @for (column of table.columns; track column.id) {
          <clr-dg-column [clrDgField]="column.id">
            <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['szumzid'] }">
              {{ column.id | mrTranslate }}
            </ng-container>
          </clr-dg-column>
        }
        <ng-template
          clrVirtualScroll
          let-row
          [clrVirtualRowsOf]="table.rows"
          [clrVirtualRowsTrackBy]="(_, row) => row?.ID">
          <clr-dg-row [clrDgItem]="row">
            @for (cell of table.columns; track cell.id) {
              <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
            }
          </clr-dg-row>
        </ng-template>
        <clr-dg-footer>{{ table.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
      </clr-datagrid>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn" (click)="isHistorieModalOpen.set(false)">
      {{ 'Schliessen' | mrTranslate }}
    </button>
  </div>
</clr-modal>
